import React from 'react'
import s from './GeoentitiesAtAddressPicker.less'
import ScrollListWithTitle from '../genericComponents/ScrollListWithTitle'
import { loadCompleteGeoentitiesAtAddressConfiguration } from '../../store/poiassets/poiassets.actions'
import { selectCompleteGeoentitiesAddressConfig } from '../../store/poiassets/poiassets.selectors'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { withFrenchSite } from '../i18n/i18nSite'
import CircledButtonWithLabel2 from '../genericComponents/CircledButtonWithLabel2'
import TagActionButton from '../genericComponents/TagActionButton'
import { navigateToSearchByApp, navigateToSearchBySubcategory } from '../../store/history/history.actions'
import { TAG_CATEGORY_LIST } from '../analytics/analytics.tagids.constants'
import { useDataLoader } from '../utils/dataLoader'
import { APP_OR_SUBCAT_ID, CAT_ID } from '../analytics/ClickTagsService'
import { useAction } from '../utils/react-redux'

const GeoentitiesAtAddressPicker = ({ title = 'A proximité' }) => {
  const geoentitiesAtAddressConfig = useDataLoader(
    loadCompleteGeoentitiesAtAddressConfiguration,
    selectCompleteGeoentitiesAddressConfig
  )
  const execNavigateToSearchByApp = useAction(navigateToSearchByApp)
  const execNavigateToSubcategory = useAction(navigateToSearchBySubcategory)

  if (geoentitiesAtAddressConfig instanceof Array && !geoentitiesAtAddressConfig.length) {
    return <></>
  }

  const onClick = ({ type, id }) => {
    if (type === 'application') {
      execNavigateToSearchByApp(id)
    } else if (type === 'subcategory') {
      execNavigateToSubcategory(id)
    }
  }

  return (
    <div className={s.root}>
      <ScrollListWithTitle
        title={title}
        data={geoentitiesAtAddressConfig}
        render={({ id, rubric, type, catId, ...restProps }) => (
          <TagActionButton key={id} type={TAG_CATEGORY_LIST} tagInfo={{ [APP_OR_SUBCAT_ID]: id, [CAT_ID]: catId }}>
            <CircledButtonWithLabel2 id={id} {...restProps} onClick={() => onClick({ type, id, rubric })} />
          </TagActionButton>
        )}
      />
    </div>
  )
}

export default withFrenchSite(withEmptyFallbackErrorBoundary(GeoentitiesAtAddressPicker))
